import { render, staticRenderFns } from "./checkreviews.vue?vue&type=template&id=7325b47a&scoped=true"
import script from "./checkreviews.vue?vue&type=script&lang=js"
export * from "./checkreviews.vue?vue&type=script&lang=js"
import style0 from "./checkreviews.vue?vue&type=style&index=0&id=7325b47a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7325b47a",
  null
  
)

export default component.exports